import React, { createContext, useContext, useState, useEffect } from 'react';

interface HotkeyContextType {
  showHints: boolean;
}

const HotkeyContext = createContext<HotkeyContextType>({ showHints: false });

export function HotkeyProvider({ children }: { children: React.ReactNode }) {
  const [showHints, setShowHints] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Control') {
        setShowHints(true);
      }
    };

    const handleKeyUp = (event: KeyboardEvent) => {
      if (event.key === 'Control') {
        setShowHints(false);
      }
    };

    const handleBlur = () => {
      setShowHints(false);
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);
    window.addEventListener('blur', handleBlur);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
      window.removeEventListener('blur', handleBlur);
    };
  }, []);

  return (
    <HotkeyContext.Provider value={{ showHints }}>
      {children}
    </HotkeyContext.Provider>
  );
}

export function useHotkeyHints() {
  const context = useContext(HotkeyContext);
  if (context === undefined) {
    throw new Error('useHotkeyHints must be used within a HotkeyProvider');
  }
  return context.showHints;
}
